import Vue from 'vue';
import Vuex from 'vuex';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';
import {MessageModel} from '@/models/Message.model';
import {Module} from 'vuex';
import {RootState} from '@/store';

Vue.use(Vuex);

export interface MessageState {
    messages: MessageModel[];
}

// message state model init
export const initialState = (): MessageState => {
    return {
        messages: []
    };
};

export const message: Module<MessageState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
};
